// Campus photo for /colleges/university-at-buffalo-suny: CC BY-SA 4.0, by Andre Carrotflower, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAutumn_colors_on_the_University_at_Buffalo_North_Campus%2C_Amherst%2C_New_York_-_20221016.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-at-buffalo-suny/; credited under the photo.
const photo = {
    "slug": "university-at-buffalo-suny",
    "alt": "Autumn trees and campus buildings on the University at Buffalo North Campus in Amherst, New York",
    "src": "/colleges/university-at-buffalo-suny/campus-1600.webp",
    "srcSmall": "/colleges/university-at-buffalo-suny/campus-800.webp",
    "srcMid": "/colleges/university-at-buffalo-suny/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-at-buffalo-suny/og.jpg",
    "title": "Autumn colors on the University at Buffalo North Campus, Amherst, New York - 20221016",
    "author": "Andre Carrotflower",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAutumn_colors_on_the_University_at_Buffalo_North_Campus%2C_Amherst%2C_New_York_-_20221016.jpg",
    "read": "2026-10-01"
};

export default photo;
